<template>
  <Title :title="title" />
  <TotalData />
  <Accordion />
</template>

<script>
import { useToast } from 'vue-toastification';
import { mapState } from 'vuex';
import Title from '../components/ViewsTitle/HomeTitle.vue'
import TotalData from '../components/Home/HomeStationsInformation.vue'
import Accordion from '../components/Home/HomeAccordion.vue'

export default {
  name: "Home",
  components: {
    Title,
    TotalData,
    Accordion
  },
  data() {
    return {
      title: 'Datos Generales'
    }
  },
  methods: {
    computed: {
      ...mapState(['seeToast', 'userAction']),
    },
    showToast(){
      const toast = useToast()
      switch (this.userAction) {
        case 'Delete':
          toast.success("El usuario ha sido eliminado.", {
          timeout: 7000
          })
          break;
        case 'Create':
          toast.success("El usuario ha sido creado con éxito.", {
          timeout: 7000
          })
          break;
        case 'Edit':
          toast.success("El usuario ha sido editado.", {
          timeout: 7000
          })
          break;
        default:
          break;
      }
      this.$store.commit('activate_toast')
    },
  },
  created(){
    this.$store.dispatch('getStations')
  },
  mounted() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push("/Login");
    }
    this.$store.dispatch("sidebar_state", "start");
    if(this.seeToast){
      this.showToast()
    }
  }
};
</script>